import API from "./api";
import router from "../router";

export default {
  fetchTeams() {
    return API().get("teams");
  },
  fetchClusterTeams(id) {
    return API().get(`teams/cluster/${id}`);
  },
  createTeam(props) {
    console.log("create, ", props);

    return API().post("teams", props);
  },
  getOneTeam(id) {
    return API().get(`teams/${id}`);
  },
  updateTeam(props) {
    console.log("update, ", props);
    return API().put(`teams/${router.currentRoute.params.id}`, props);
  },
  updateTeamActive(props) {
    console.log(props);

    return API().put(`teams/${props.id}`, props);
  },
  deleteTeam(id) {
    return API().delete(`teams/${id}`);
  },
  deleteTrainer(trainerId) {
    return API().delete(
      `teams/${router.currentRoute.params.id}/trainer/${trainerId}`
    );
  },
  addTrainer(trainerId) {
    return API().post(
      `teams/${router.currentRoute.params.id}/trainer/${trainerId}`
    );
  },
  fetchTrainers() {
    return API().get(`teams/${router.currentRoute.params.id}/trainers`);
  },
};
